import { initApplication } from 'utils/initApplication';
import { Application } from 'Application';
import React from 'react'
import ReactDOM from 'react-dom/client'

initApplication()
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><Application /></React.StrictMode>)

